export default "__VITE_ASSET__dd85b704__"